'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  242: 'fulltime',
  243: 'parttime',
  244: 'contracttemp',
  245: 'casualvacation'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-react-gpt/build/targeting/worktypes.js
 ** module id = 829
 ** module chunks = 0
 **/